<div class="header" i18n [attr.data-testid]="'poster-editor-header'">
  {{ title }}
</div>

<div class="container" [attr.data-testid]="'poster-editor-container'">
  <gosu-image-picker
    [(value)]="poster.content"
    [useCode]="true"
    [autoSize]="true"
    [width]="1040"
    [attr.data-testid]="'poster-image-picker'"
  >
  </gosu-image-picker>

  @for (area of poster.areas; track $index) {
    <div class="area" [attr.data-testid]="'poster-area'">
      <mat-form-field
        class="select"
        legacyAppearance
        [attr.data-testid]="'area-type-field'"
      >
        <mat-label i18n>類型</mat-label>
        <mat-select
          [(ngModel)]="area.type"
          (ngModelChange)="onTypeChanged(area)"
          i18n
          [attr.data-testid]="'area-type-select'"
        >
          @if (package.enabledActions.uri) {
            <mat-option value="uri" [attr.data-testid]="'uri-option'">
              連結
            </mat-option>
          }

          @if (package.enabledActions.message) {
            <mat-option value="message" [attr.data-testid]="'message-option'">
              說話
            </mat-option>
          }

          @if (packageFactoryService.enablePromotionChannel$ | async) {
            <ng-container>
              @if (package.enabledActions.shareMessageThroughPromotion) {
                <mat-option
                  value="share-message-through-promotion"
                  [attr.data-testid]="'share-promotion-option'"
                >
                  分享機器人 (推廣通路)
                </mat-option>
              }

              @if (package.enabledActions.addThroughPromotion) {
                <mat-option
                  value="add-through-promotion"
                  [attr.data-testid]="'add-promotion-option'"
                >
                  加入機器人 (推廣通路)
                </mat-option>
              }
            </ng-container>
          }

          @if (konamiCode.unlock$ | async) {
            @if (package.enabledActions.shareMessage) {
              <mat-option value="share-message"> 分享訊息 </mat-option>
            }

            @if (package.enabledActions.addFriend) {
              <mat-option value="add-friend"> 加入 LINE 官方帳號 </mat-option>
            }

            @if (package.enabledActions.addFriend) {
              <mat-option value="share-add-friend">
                分享訊息並邀請好友加入 LINE 官方帳號
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>

      @if (area.type === 'message') {
        <mat-form-field
          floatLabel="always"
          legacyAppearance
          [attr.data-testid]="'message-content-field'"
        >
          <mat-label i18n>訊息內容</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="area['content']"
            [attr.data-testid]="'message-content-input'"
          />
        </mat-form-field>
      }

      @if (area.type === 'uri') {
        <mat-form-field
          floatLabel="always"
          legacyAppearance
          [attr.data-testid]="'uri-field'"
        >
          <input
            matInput
            type="text"
            placeholder="網址"
            i18n-placeholder="網址"
            [(ngModel)]="area['content']"
            [attr.data-testid]="'uri-input'"
          />

          <button
            mat-icon-button
            matSuffix
            (click)="openUrlBuilderDialog(area)"
            matTooltip="編輯 UTM 參數"
            i18n-matTooltip="編輯 UTM 參數"
          >
            <mat-icon> edit </mat-icon>
          </button>

          <gosu-validator
            [(ngModel)]="area.content"
            [rules]="{ required: true, uri: true }"
            [offsetY]="20"
            [attr.data-testid]="'uri-validator'"
          ></gosu-validator>
        </mat-form-field>
      }

      @if (area.type === 'share-message-through-promotion') {
        <mat-form-field
          legacyAppearance
          floatLabel="always"
          [attr.data-testid]="'promotion-field'"
        >
          <mat-label i18n>推廣通路</mat-label>
          <mat-select
            [(ngModel)]="area['promotionId']"
            [attr.data-testid]="'promotion-select'"
          >
            @for (promotion of promotions$ | async; track promotion.id) {
              <mat-option
                [value]="promotion.id"
                [attr.data-testid]="'promotion-option-' + promotion.id"
              >
                {{ promotion.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (area.type === 'share-message') {
        <ng-container>
          <div class="flex items-center gap-1">
            <mat-form-field
              floatLabel="always"
              class="select"
              legacyAppearance
              *asyncJob="
                messageManagementService.selectShareMessagesTree$;
                let selectMessagesTree
              "
            >
              <mat-label i18n>
                <div class="flex items-center gap-1">
                  分享訊息
                  <mat-icon
                    [matTooltip]="option_tooltip"
                    class="!text-[20px] !w-[20px] !h-[20px]"
                    >help</mat-icon
                  >
                  <ng-template #option_tooltip>
                    <ms-share-message-hint
                      [type]="'share-message'"
                    ></ms-share-message-hint>
                  </ng-template>
                </div>
              </mat-label>
              <input
                matInput
                [matTreePicker]="treePicker"
                readonly
                class="cursor-pointer"
                [value]="area.shareMessageName ?? ''"
              />
              <button mat-icon-button matSuffix class="!w-6 !h-6">
                <mat-icon class="!w-5 !h-5">arrow_drop_down</mat-icon>
              </button>
              <mat-tree-picker
                #treePicker
                side="right"
                [dataSource]="filterDataSource(selectMessagesTree)"
              >
                <mat-tree-picker-node
                  *matTreePickerNodeDef="let item"
                  (selected)="selectMessage(area, $event, treePicker)"
                  [attr.disabled]="
                    item.type === 'message' && !item.isShareable ? '' : null
                  "
                >
                  @if (
                    item.type === 'create-folder' ||
                    item.type === 'create-message'
                  ) {
                    <div class="text-center px-5 flex items-center gap-1">
                      <mat-icon class="!leading-none">add</mat-icon>
                      <span i18n>{{ item.name }}</span>
                    </div>
                  } @else {
                    {{ item.name }}
                  }
                </mat-tree-picker-node>
              </mat-tree-picker>
            </mat-form-field>
            @if (area.messageId) {
              <button mat-icon-button matSuffix (click)="editMessage(area)">
                <mat-icon>edit</mat-icon>
              </button>
            } @else {
              <button
                mat-icon-button
                matSuffix
                matTooltip="建立分享訊息"
                i18n-matTooltip="建立分享訊息"
                (click)="createMessage(area)"
              >
                <mat-icon>add</mat-icon>
              </button>
            }
          </div>
        </ng-container>
      }

      @if (area.type === 'share-add-friend') {
        <ng-container>
          <div class="flex items-center gap-1">
            <mat-form-field
              floatLabel="always"
              class="select"
              legacyAppearance
              *asyncJob="
                messageManagementService.selectAddFriendThroughShareMessagesTree$;
                let selectMessagesTree
              "
            >
              <mat-label i18n>
                <div class="flex items-center gap-1">
                  分享訊息
                  <mat-icon
                    [matTooltip]="option_tooltip"
                    class="!text-[20px] !w-[20px] !h-[20px]"
                    >help</mat-icon
                  >
                  <ng-template #option_tooltip>
                    <ms-share-message-hint
                      [type]="'share-add-friend'"
                    ></ms-share-message-hint>
                  </ng-template>
                </div>
              </mat-label>
              <input
                matInput
                [matTreePicker]="treePicker"
                readonly
                class="cursor-pointer"
                [value]="area.shareMessageName ?? ''"
              />
              <button mat-icon-button matSuffix class="!w-6 !h-6">
                <mat-icon class="!w-5 !h-5">arrow_drop_down</mat-icon>
              </button>
              <mat-tree-picker
                #treePicker
                side="right"
                [dataSource]="selectMessagesTree"
              >
                <mat-tree-picker-node
                  *matTreePickerNodeDef="let item"
                  (selected)="selectMessage(area, $event, treePicker)"
                  [attr.disabled]="
                    item.type === 'message' && !item.isAddFriendThroughShare
                      ? ''
                      : null
                  "
                >
                  @if (
                    item.type === 'create-folder' ||
                    item.type === 'create-message'
                  ) {
                    <div class="text-center px-5 flex items-center gap-1">
                      <mat-icon class="!leading-none">add</mat-icon>
                      <span i18n>{{ item.name }}</span>
                    </div>
                  } @else {
                    {{ item.name }}
                  }
                </mat-tree-picker-node>
              </mat-tree-picker>
            </mat-form-field>
            @if (area.messageId) {
              <button mat-icon-button matSuffix (click)="editMessage(area)">
                <mat-icon>edit</mat-icon>
              </button>
            } @else {
              <button
                mat-icon-button
                matSuffix
                matTooltip="建立分享訊息"
                i18n-matTooltip="建立分享訊息"
                (click)="createMessage(area)"
              >
                <mat-icon>add</mat-icon>
              </button>
            }
          </div>
        </ng-container>
      }
    </div>
  }
</div>

<div class="footer text-right" [attr.data-testid]="'poster-editor-footer'">
  <button
    mat-raised-button
    (click)="submit()"
    color="primary"
    i18n
    [attr.data-testid]="'submit-button'"
  >
    製作完成
  </button>
</div>
